var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDoubleArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7035 11.3005C13.8977 11.4767 14 11.7358 14 11.9948C14 12.2642 13.8977 12.5026 13.7035 12.6995L5.60532 20.7202C5.42127 20.8964 5.19632 21 4.9407 21C4.409 21 4 20.5959 4 20.057C4 19.7876 4.10225 19.5492 4.26585 19.3834L11.7096 11.9948L4.26585 4.61658C4.10225 4.44041 4 4.20207 4 3.943C4 3.40414 4.409 3 4.9407 3C5.19632 3 5.42127 3.10363 5.59509 3.27979L13.7035 11.3005Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7035 11.3005C19.8977 11.4767 20 11.7358 20 11.9948C20 12.2642 19.8977 12.5026 19.7035 12.6995L11.6053 20.7202C11.4213 20.8964 11.1963 21 10.9407 21C10.409 21 10 20.5959 10 20.057C10 19.7876 10.1022 19.5492 10.2658 19.3834L17.7096 11.9948L10.2658 4.61658C10.1022 4.44041 10 4.20207 10 3.943C10 3.40414 10.409 3 10.9407 3C11.1963 3 11.4213 3.10363 11.5951 3.27979L19.7035 11.3005Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoubleArrowRight);
export default __webpack_public_path__ + "static/media/icon-double-arrow-right.700965ffa088db58caf1402c20d4c4bc.svg";
export { ForwardRef as ReactComponent };